// Kraft cocktail bar — menu data extracted from the printed menu pages.
// All prices are in PLN.

const menu = [
  {
    id: "draft",
    name: "Homemade Draft",
    tagline: "Cocktails on tap, crafted in-house",
    items: [
      { name: "Negroni", price: 40 },
      { name: "Pornstar Martini", price: 40 },
      { name: "Nitro Espresso Martini", price: 40 },
      { name: "Strawberry Daiquiri", price: 35 },
      { name: "Polish Spritz", price: 35 },
      { name: "Hugo Spritz", price: 35 },
      { name: "Aperol Spritz", price: 35 },
      { name: "Paloma", price: 35 },
      { name: "Paloma 0%", price: 22 },
      { name: "Lemonade", price: 22 },
      { name: "Nitro Cold Brew", price: 25 },
    ],
  },
  {
    id: "vodka",
    name: "Wódka",
    tagline: "Polish & international vodka selection",
    items: [
      { name: "Żubrówka Czarna", price: 16 },
      { name: "Żubrówka Bison Grass", price: 16 },
      { name: "Ostoya", price: 18 },
      { name: "Chopin Rye", price: 24 },
      { name: "Chopin Potato", price: 30 },
      { name: "Młody Ziemniak 2023", price: 40 },
      { name: "Belvedere", price: 34 },
      { name: "Belvedere Lake", price: 50 },
      { name: "Belvedere Forest", price: 50 },
      { name: "Krzeska", price: 40 },
      { name: "Nikka Coffey", price: 30 },
    ],
  },
  {
    id: "gin",
    name: "Gin",
    tagline: "Botanical classics & modern editions",
    items: [
      { name: "Gordon's", price: 20 },
      { name: "Beefeater", price: 20 },
      { name: "Beefeater Pink", price: 20 },
      { name: "Bombay Sapphire", price: 25 },
      { name: "Tanqueray Ten", price: 30 },
      { name: "Hendrick's", price: 30 },
      { name: "Monkey 47", price: 38 },
      { name: "Roku", price: 26 },
      { name: "Nikka Coffey", price: 28 },
    ],
  },
  {
    id: "rum",
    name: "Rum",
    tagline: "From light cane to deep-aged reserve",
    items: [
      { name: "Planteray 3 Stars", price: 20 },
      { name: "Planteray Pineapple", price: 25 },
      { name: "Planteray Dark", price: 22 },
      { name: "Planteray XO", price: 36 },
      { name: "Planteray O.F.T.D.", price: 30 },
      { name: "Sailor Jerry", price: 22 },
      { name: "Kraken", price: 22 },
      { name: "Leblon", price: 30 },
      { name: "Stroh 80", price: 30 },
      { name: "Compañero Gran Reserva Jamaica – Trinidad", price: 30 },
      { name: "Compañero Elixir Extra", price: 30 },
      { name: "Compañero Elixir Orange", price: 26 },
      { name: "Compañero Extra Añejo Panama", price: 32 },
    ],
  },
  {
    id: "tequila",
    name: "Tequila & Mezcal",
    tagline: "Agave spirits, sipped slow",
    items: [
      { name: "Jose Cuervo Silver", price: 24 },
      { name: "Jose Cuervo Reposado", price: 24 },
      { name: "Clase Azul Plata", price: 75 },
      { name: "Clase Azul Reposado", price: 100 },
      { name: "Casamigos Blanco", price: 44 },
      { name: "Casamigos Reposado", price: 52 },
      { name: "Casamigos Añejo", price: 56 },
      { name: "Casamigos Mezcal", price: 70 },
      { name: "Koch Mezcal", price: 28 },
      { name: "Del Maguey Vida", price: 46 },
    ],
  },
  {
    id: "whisky-scotch",
    name: "Whisky — Szkocja",
    tagline: "Single malts and blends from Scotland",
    items: [
      { name: "Monkey Shoulder", price: 32 },
      { name: "Chivas 12", price: 25 },
      { name: "Johnnie Walker Black", price: 28 },
      { name: "Auchentoshan 12", price: 34 },
      { name: "Glenfiddich 12", price: 34 },
      { name: "Glenfiddich 18", price: 70 },
      { name: "Macallan 12", price: 50 },
      { name: "Macallan 15", price: 80 },
      { name: "Talisker", price: 36 },
      { name: "Talisker Skye", price: 34 },
      { name: "Lagavulin 16", price: 60 },
      { name: "Coal Ila 12", price: 46 },
      { name: "Octomore 15.3", price: 120 },
      { name: "Signatory Vintage Whitlaw 9", price: 60 },
      { name: "Signatory Vintage Ben Nevis 5", price: 60 },
      { name: "Signatory Vintage The Glenlivet 13", price: 90 },
      { name: "Signatory Vintage Mortlach 10", price: 70 },
      { name: "Signatory Vintage Coal Ila 18", price: 130 },
    ],
  },
  {
    id: "whisky-american",
    name: "Whiskey — Ameryka",
    tagline: "Bourbon, rye and craft American",
    items: [
      { name: "Jack Daniel's", price: 25 },
      { name: "Jim Beam", price: 22 },
      { name: "Wild Turkey", price: 26 },
      { name: "Wild Turkey 101", price: 32 },
      { name: "Wild Turkey Rye", price: 30 },
      { name: "Wild Turkey Longbranch", price: 36 },
      { name: "Bulleit Rye", price: 30 },
      { name: "Bulleit Bourbon", price: 25 },
      { name: "Woodford", price: 34 },
      { name: "Woodford Double Oaked", price: 46 },
      { name: "Woodford Rye", price: 35 },
      { name: "Sazerac", price: 32 },
      { name: "Blanton's", price: 70 },
    ],
  },
  {
    id: "whisky-irish-jp",
    name: "Whisky — Irlandia & Japonia",
    tagline: "Smooth Irish drams & refined Japanese whisky",
    items: [
      { name: "Jameson", price: 22 },
      { name: "Bushmills Black", price: 22 },
      { name: "Bushmills 16", price: 40 },
      { name: "Connemara", price: 32 },
      { name: "Redbreast 15", price: 70 },
      { name: "Nikka Coffey", price: 38 },
      { name: "Nikka From The Barrel", price: 36 },
      { name: "Hibiki", price: 84 },
    ],
  },
  {
    id: "brandy",
    name: "Brandy & Spirits",
    tagline: "Cognac, calvados, śliwowica & absinthe",
    items: [
      { name: "Hennessy", price: 36 },
      { name: "Cointreau Noir", price: 30 },
      { name: "Calvados Boulard VSOP", price: 38 },
      { name: "Metaxa 12", price: 28 },
      { name: "Śliwowica Podbeskidzka 50%", price: 28 },
      { name: "Śliwowica Podbeskidzka 72%", price: 30 },
      { name: "Pernod Absinthe", price: 38 },
    ],
  },
  {
    id: "wine",
    name: "Wine",
    tagline: "By the glass and by the bottle",
    items: [
      { name: "Cava (glass)", price: 15 },
      { name: "Pinot Grigio (glass)", price: 15 },
      { name: "Primitivo (glass)", price: 15 },
      { name: "Moët Brut", price: 400 },
      { name: "Moët Rosé", price: 600 },
      { name: "Dom Pérignon 2015", price: 2000 },
    ],
  },
  {
    id: "cafe",
    name: "Café",
    tagline: "Espresso bar, all day",
    items: [
      { name: "Caffè", price: 12 },
      { name: "Americano", price: 12 },
      { name: "Flat White", price: 15 },
      { name: "Espresso Tonic", price: 20 },
    ],
  },
];

export default menu;
